export default {
  type: 'split',
  handler: (model, value, attr) => {
    const {
      index = -1,
      splitKey = ':'
    } = model;
    // this lets us do things like -1 index for last
    return value?.split(splitKey).slice(index)[0];
  }
};